import { FlexBox } from '@ardoq/layout';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { colors, radius } from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';

type PillProps = {
  children: ReactNode;
};

const PillContainer = styled(FlexBox).attrs({ padding: 'none' })`
  ${text2};
  box-sizing: border-box;
  background-color: ${colors.surfaceDefault};
  border: 1px solid ${colors.borderSubtle};
  overflow: hidden;
  width: fit-content;
  max-width: 100%;
  min-width: 0;

  /* Round the Close button to match the container radius so their inset focus
     ring follows the pill's rounded corners instead of being clipped by
     overflow: hidden. 
     First child is not an interactive element, so no need to round it. */
  & > button:last-child {
    border-top-right-radius: ${radius.large};
    border-bottom-right-radius: ${radius.large};
  }
`;

const Separator = styled.div`
  border-right: 1px solid ${colors.borderSubtle};
  width: 1px;
`;

export const Pill = ({ children }: PillProps) => (
  <PillContainer borderRadius="large" padding="small" align="stretch">
    {React.Children.map(children, (child, index) => (
      <>
        {child}
        {child && index < React.Children.count(children) - 1 && <Separator />}
      </>
    ))}
  </PillContainer>
);
